require('./brokerMarketsFinancesNewsDetailView.scss');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const moment = require('moment');
const { Link } = require('react-router-dom');
const classnames = require('classnames');

// @components
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKBoxSectionContent } = require('commonsComponents/OKBoxSectionContent');
const { OKBoxNewPreview } = require('commonsComponents/OKBoxNewPreview');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const OKLoadingErrorMessage = require('components/commons/OKLoadingErrorMessage/OKLoadingErrorMessage');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const { getFirstNWords } = require('utilities/stringHelper');

// @actions
const brokerMarketsActions = require('actions/brokerMarkets');

// @constants
const DATE_FORMAT_TYPES = require('commonsConstants/dateFormatTypes');
const { DEFAULT_COUNTRY } = require('constants/index');
const {
    OTHER_NEWS,
    DETAIL_NEW
} = require('constants/brokerMarkets');

class BrokerMarketsFinancesNewsDetailView extends React.Component {
    componentDidMount() {
        const { immBrokerMarket, requestFinancesNews } = this.props;

        if (immBrokerMarket.get('financesNews').length === 0)
            requestFinancesNews();
    }

    buildBreadCrumb = () => {
        const { match: { params } } = this.props;

        return (
            [
                {
                    text: <FormattedText value="brokerMarketNews-savingsTitlte" />,
                    url: '/myprofile/broker'
                },
                {
                    text: <FormattedText value="broker-marketsTitle" />,
                    url: '/myprofile/broker/markets'
                },
                {
                    text: <FormattedText value="brokerMarketNews-financesNewsTitle" />,
                    url: '/myprofile/broker/markets/finances-news'
                },
                {
                    text: params ? getFirstNWords(params.idNew) : '',
                    url: ''
                }
            ]
        )
    }

    buildNewsSections = (type) => {
        const { immBrokerMarket } = this.props;
        const loading = immBrokerMarket.get('fetchingFinancesNews');
        const error = immBrokerMarket.get('errorFinancesNews');

        return (
            <OKLoadingErrorMessage
                isLoading={loading}
                isError={error}
            >
                {type === DETAIL_NEW ? this.buildDetail() : this.buildOtherNewsSection()}
            </OKLoadingErrorMessage>
        );
    }

    buildDetail = () => {
        const { immBrokerMarket, match: { params }, originCountry } = this.props;
        const financesNewContent = immBrokerMarket.get('financesNews');

        const financesNewsClass = classnames('broker-markets-finances-news-detail__body', {
            'broker-markets-finances-news-detail__body--last-bold': originCountry === DEFAULT_COUNTRY,
        });

        if (financesNewContent.length) {
            const financesDetail = financesNewContent.find(f => f.title1 && f.title1.trim() === params.idNew.trim());
            return (
                <React.Fragment>
                    <div className="broker-markets-finances-news-detail__header">
                        <OKBoxNewPreview
                            title={financesDetail.title1}
                            date={moment(financesDetail.creationDate).format(DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT_DATETIME)}
                            hasCover
                            coverImage={financesDetail.viewRef}
                            positionImage="LEFT"
                            heightImage={350}
                        />
                    </div>
                    <div className={financesNewsClass}>
                        <HTMLSafeInjector
                            message={financesDetail.text.replace(/<[\/]{0,1}(Origin|ORIGIN|origin)[^><]*>/g, "originTag").split('originTag')[0]}
                        />
                    </div>
                </React.Fragment>
            )
        }
        return null;
    }

    buildOtherNewsSection = () => {
        const { immBrokerMarket, match: { params }, originCountry } = this.props;

        const grid = immBrokerMarket.get('financesNews')
            .filter(f => f.title1 && f.title1.trim() !== params.idNew.trim()).slice(0, 3).map((news, index) => {
                return (
                    <div className="col-xs-4" key={index.toString()}>
                        <div className="box-news-content">
                            <OKBoxNewPreview
                                title={news.title1}
                                description={getFirstNWords(news.title2)}
                                date={moment(news.creationDate).format(DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT_DATETIME)}
                                hasCover
                                coverImage={news.viewRef}
                                linkContent={
                                    <Link to={`/myprofile/broker/markets/finances-news-detail/${encodeURIComponent(news.title1)}`}>
                                        <FormattedText value="brokerMarketNews-readMoreNews" />
                                    </Link>
                                }
                            />
                        </div>
                    </div>
                )
            })

        return grid;
    }

    render() {
        return (
            <div className="broker-markets-finances-news-detail">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="broker" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={this.buildBreadCrumb()}
                                finalTitle={<FormattedText value="brokerMarketNews-financesNewsTitle" />}
                            >
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>

                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="broker-markets-finances-news-detail__box-news">
                                <OKBoxSectionContent
                                    content={this.buildNewsSections(DETAIL_NEW)}
                                    hasFooter
                                    footerContentLeft={
                                        <Link to="/myprofile/broker/markets/finances-news">
                                            <FormattedText value="brokerMarketNews-returnNews" />
                                        </Link>
                                    }
                                />
                            </div>
                            <div className="broker-markets-finances-news-detail__other-news-section">
                                <OKBoxSectionContent
                                    title={<FormattedText value="brokerMarketNews-otherNewsTitle" />}
                                    className="row"
                                    content={this.buildNewsSections(OTHER_NEWS)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BrokerMarketsFinancesNewsDetailView.propTypes = {
    immBrokerMarket: PropTypes.object,
    match: PropTypes.object,
    requestFinancesNews: PropTypes.func,
    originCountry: PropTypes.string,
};

module.exports.constructor = BrokerMarketsFinancesNewsDetailView;
module.exports.BrokerMarketsFinancesNewsDetailView = connect(
    state => ({
        immBrokerMarket: state.brokerMarkets,
        originCountry: state.profile.get('originCountry')
    }), {
    requestFinancesNews: brokerMarketsActions.requestFinancesNews
})(BrokerMarketsFinancesNewsDetailView);
